import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
} from '@mui/material';
import LockClockRoundedIcon from '@mui/icons-material/LockClockRounded';

interface Props {
  open: boolean;
  /** Stay on GradMap (close the modal, do not navigate). */
  onClose: () => void;
  /** Re-authenticate: sends the user to CAM's login page (which itself redirects
   * through GradMap OAuth login since the GradMap session has expired). */
  onLogin: () => void;
}

/**
 * Shown when the user clicks the CAM sidebar button but the GradMap session
 * (access token) has already timed out. Replaces the old "toast + silent
 * reload" behavior, which never actually took the user to CAM login.
 */
const CamSessionExpiredModal = (props: Props) => {
  const { open, onClose, onLogin } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableScrollLock
      container={typeof document !== 'undefined' ? document.body : undefined}
      sx={{ zIndex: 14000 }}
      PaperProps={{ sx: { borderRadius: 3, minWidth: 380, maxWidth: 480 } }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: 20, pt: 3 }}>
        <LockClockRoundedIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
        <Box>Session expired</Box>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{ textAlign: 'center', fontSize: 15, mt: 1, mb: 1, color: 'text.secondary' }}
        >
          Your GradMap session has timed out. Please log in again to continue to CAM (College
          Application Manager).
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 3 }}>
        <Button onClick={onLogin} variant="contained" color="primary" sx={{ minWidth: 160, mr: 1 }}>
          Log in to CAM
        </Button>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={{ minWidth: 120 }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CamSessionExpiredModal;
